module.exports = __webpack_public_path__ + "img/icon-docs.e17baa50.svg";